import { useQuery } from "@apollo/client";
import { useState, createContext, useContext, useMemo } from "react";
import { GET_TAGS } from "services/apollo/Queries";
import { useAdmin } from "features/admin/AdminContext";

export const TagContext = createContext();

export const TagProvider = ({ children }) => {
    const { user, setUser, all_users, setAll_users } = useAdmin();
    const [loader, setLoader] = useState(true);
    const [activeTag, setActiveTag] = useState(null);
    const [filterState, setFilterState] = useState('');
    const [searchString, setSearchString] = useState('');
    const [sort, setSort] = useState('asc');
    const [tags, setTags] = useState([]);

    useQuery(GET_TAGS, {
        fetchPolicy: 'no-cache',
        variables: { company_id: user?.company_id, admin_setting: 'yes' },
        onCompleted: (data) => {
            console.log(36, data);

            if (data?.tags) {
                setTags(data.tags.public?.filter(f => f.title !== 'UNTAGGED FILES'))
                setLoader(false)
            }
        }
    });

    const filteredUsers = useMemo(() => {
        let data = tags;

        // Filter by search string
        if (searchString) {
            const lower = searchString.toLowerCase();
            data = data.filter(t =>
                t.title.toLowerCase().includes(lower)
            );
        }

        // Sort by title (asc/desc)
        data = [...data].sort((a, b) => {
            const nameA = a.title.toLowerCase();
            const nameB = b.title.toLowerCase();

            return sort === "asc" ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        });

        return data;
    }, [tags, searchString, sort]);


    const contextValue = useMemo(() => ({
        loader,
        all_users,
        setAll_users,
        user,
        setUser,
        searchString,
        setSearchString,
        filterState,
        setFilterState,
        activeTag,
        setActiveTag,
        tags: filteredUsers,
        setTags,
        sort,
        setSort,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [loader, all_users, user, searchString, filterState, activeTag, filteredUsers, sort]);

    return (
        <TagContext.Provider value={contextValue}>
            {children}
        </TagContext.Provider>
    );
};

export const useTags = () => {
    const context = useContext(TagContext);
    if (!context) {
        throw new Error("useTags must be used within a TagProvider");
    }
    return context;
};